import { Navigate } from "react-router-dom";
import { CONTRACTS_PATH } from "../../../paths";

export const HomePage = () => {
  return <Navigate to={CONTRACTS_PATH} />;
};
